import { Component, OnInit } from '@angular/core';
import { DateAdapter } from '@angular/material/core';
import { MatDialog } from '@angular/material/dialog';
import { ShareService } from '@nttp/common-service/share-service';
import { TableCellTypes } from '@nttp/enum/table-cell-type-enum';
import { UserRoleEnum } from '@nttp/enum/user-role.enum';
import { ActionTypes } from '@pg-app/shared/constants/action-types-constants';
import { ToastrService } from 'ngx-toastr';
import { RegistrationStep2Service } from '../services/registrationStep2.service';
import { SingleUltimateRemitterComponent } from './dialogs/single-ultimate-remitter/single-ultimate-remitter.component';
import { ManageUltimateRemittersService } from './manage-ultimate-remitters.service';
import { environment } from '@pg-env/environment';
import { RemitterTypes } from '../payment/constants/remitter-type';

@Component({
  selector: 'np-manage-ultimate-remitters',
  templateUrl: './manage-ultimate-remitters.component.html',
  styleUrls: ['./manage-ultimate-remitters.component.scss'],
})
export class ManageUltimateRemittersComponent implements OnInit {
  isLoading = true;

  columns = [
    {
      title: 'Type',
      name: 'typeName',
      width: '140px',
      filterList: RemitterTypes,
      filterAndSortName: 'type'
    },
    {
      title: 'Last Name',
      name: 'lastName',
      width: '120px',
    },
    {
      title: 'First Name',
      name: 'firstName',
      width: '120px',
    },
    {
      title: 'Date of Birth',
      name: 'dateOfBirth',
      width: '150px',
      type: TableCellTypes.Date,
    },
    {
      title: 'Company Name',
      name: 'companyName',
      width: '200px',
    },
    {
      title: 'Company Number',
      name: 'companyNumber',
      width: '150px',
    },
    {
      title: 'Country',
      name: 'countryName',
      width: '200px',
    },
    {
      title: 'Address',
      name: 'address',
      width: '250px',
    },
    {
      title: 'City',
      name: 'city',
      width: '200px',
    },
    {
      title: 'Post Code',
      name: 'postCode',
      width: '150px',
    }
  ];

  rows = [];
  countries = [];

  userRoleEnum = UserRoleEnum;

  totalCount = 0;
  pageSize = environment.defaultPageSize;

  constructor(
    public registrationService: RegistrationStep2Service,
    private manageUltimateRemittersService: ManageUltimateRemittersService,
    private toastrService: ToastrService,
    private dialog: MatDialog,
    private shareService: ShareService) {
  }

  ngOnInit(): void {
    this.getCountries();
    this.tableChanged();
  }

  getUltimateRemitters() {
    this.isLoading = true;
    this.tableChanged();
  }

  tableChanged(event = null) {
    const filters = event?.filter || null;
    const params = {
      filters: filters,
      sortName: event?.sortName || "type",
      sortType: event != null ? event.sortType : 1,
      getAll: false,
      pageSize: this.pageSize,
      pageIndex: event ? event.currentPage : 1
    };

     this.manageUltimateRemittersService.getUltimateRemitters(params).subscribe(
       data => {
        const tableData = data.body || [];

        this.rows = tableData;
        const headerData = JSON.parse(data.headers.get('X-Pagination'));
        this.totalCount = headerData.TotalCount;
        this.isLoading = false;
       }
     );
  }

ultimateRemitterDblClicked($event: any) {
    const ultimateRemitter = this.rows.find(x => x.id === $event.row.id);

    if (!ultimateRemitter) {
      this.toastrService.error(`Cannot find this ultimate remitter`);
    } else {
      const dlgRef = this.dialog.open(SingleUltimateRemitterComponent, {
        disableClose: true,
        panelClass: 'custom-dialog',
        data: {
          countries: this.countries,
          ultimateRemitter: ultimateRemitter
        }
      });

      dlgRef.afterClosed().subscribe(
        result => {
          if (result == ActionTypes.Updating) {
            this.toastrService.info(`Ultimate remitter updated successfully`);
            this.getUltimateRemitters();
          } else if (result == ActionTypes.Deleting) {
            this.toastrService.info(`Ultimate remitter deleted successfully`);
            this.getUltimateRemitters();
          }
        }
      );
    }
  }

  private getCountries() {
    this.shareService.countryList$.subscribe(
      data => {
        data.forEach(item => {
          const flagIcon = (item.code.length <= 2 ? item.code : item.code.substring(0, 2)).toLowerCase();
          item.flag = `flag-icon flag-icon-${flagIcon}`;
        });
        this.countries = data || [];
      },
    );
  }

  add() {
    const dlgRef = this.dialog.open(SingleUltimateRemitterComponent, {
      disableClose: true,
      panelClass: 'custom-dialog',
      data: {
        countries: this.countries,
        ultimateRemitter: null
      }
    });

    dlgRef.afterClosed().subscribe(
      result => {
        if (result) {
          this.toastrService.info(`Ultimate remitter added successfully`);
          this.tableChanged();
        }
      }
    );
  }
}
